import { Component } from '@angular/core';
import { dropdownOption } from '../../types/common';
import { TrpcService } from '../../services/trpc/trpc.service';
import { MessageService } from 'primeng/api';
import { Account, Suite } from '../../../../../express-tRPC/src/api/invoices/types';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrl: './reports.component.scss'
})
export class ReportsComponent {

  activeStep: number = 0;
  loadingSearchOption: boolean = false;
  reportInProgress: boolean = false;

  primaryReportOptions: dropdownOption[] = [];
  secondaryReportOptions: dropdownOption[] = [];
  suiteOptions: dropdownOption[] = [];
  suiteAcctOptions: dropdownOption[] = [];

  selectedPrimaryReportOption: string = '';
  selectedSecondaryReportOption: string = '';
  selectedSuite: string = '';
  selectedSuiteAcct: string = '';

  selectedBillingMonth: Date = new Date();
  minDate: Date;
  maxDate: Date;

  selectedInvoiceRangeDates: Date[] = [new Date(), new Date()];
  selectedPaymentRangeDates: Date[] = [new Date(), new Date()];
  selectedPostedOnRangeDates: Date[] = [new Date(), new Date()];

  selectedDate: Date = new Date();

  invoiceStatusOptions: dropdownOption[] = [
    { name: "Open", code: "Open" },
    { name: "Outstanding", code: "Outstanding" },
    { name: "Credit", code: "Credit" },
    { name: "Paid", code: "Paid" },
  ];

  activeOnly: boolean = true;

  reportForm!: FormGroup;

  months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]

  constructor(
    private trpcService: TrpcService,
    private messageService: MessageService,
    private fb: FormBuilder,) {

    this.activeStep = 0;
    this.loadingSearchOption = true;

    let date = new Date();

    this.minDate = new Date();
    this.minDate.setMonth(date.getMonth() + 1);
    this.minDate.setFullYear(date.getFullYear() - 5);

    this.maxDate = new Date();

    this.getReportOptions();
  }

  ngOnInit(): void {
    this.reportForm = this.fb.group({
      primaryOption: ['', Validators.required],
      secondaryOption: ['', Validators.required],
      suite: [''],
      account: [''],
      billing_period: [''],
      invoice_date: [''],
      payment_date: [''],
      posted_on: [''],
      invoice_status: [''],
      as_of_date: [''],
      active_only: [''],
    });
  }

  async getReportOptions(selectedOption: string = ''): Promise<void> {
    let reportOptionsResult: any = await this.trpcService.trpc.reports.getReportOptions.query({ selectedOption: selectedOption }).catch((error: any) => {
      this.messageService.add({
        severity: "error",
        detail: error.message,
      });
    });
    if (reportOptionsResult?.length) {
      if (this.activeStep === 0) {
        this.primaryReportOptions = reportOptionsResult;
        // this.selectedPrimaryReportOption = reportOptionsResult[0]['code'];
      } else if (this.activeStep === 1) {
        this.secondaryReportOptions = reportOptionsResult;
        // this.selectedSecondaryReportOption = reportOptionsResult[0]['code'];
      }
    }
    this.loadingSearchOption = false;
  }

  async stepChanged(step: number) {
    this.activeStep = step;
    if (step === 0) {
      this.selectedSecondaryReportOption = '';
      this.getReportOptions();
    } else if (step === 1) {
      this.selectedSecondaryReportOption = '';

      this.resetFormValidators();

      this.getReportOptions(this.selectedPrimaryReportOption);

    } else if (step === 2) {

      this.resetFormValidators();
      this.updateFormValidators();

      if (this.selectedSecondaryReportOption == "suite" || this.selectedSecondaryReportOption == 'account') {
        await this.getSuite();
        if (this.selectedSecondaryReportOption == 'account') {
          this.getAccountBySuite()
        }
      }

    }
  }

  resetFormValidators(): void {
    this.reportForm.controls['suite'].setValidators([]);
    this.reportForm.controls['suite'].updateValueAndValidity();

    this.reportForm.controls['account'].setValidators([]);
    this.reportForm.controls['account'].updateValueAndValidity();

    this.reportForm.controls['billing_period'].setValidators([]);
    this.reportForm.controls['billing_period'].updateValueAndValidity();

    this.reportForm.controls['invoice_date'].setValidators([]);
    this.reportForm.controls['invoice_date'].updateValueAndValidity();

    this.reportForm.controls['payment_date'].setValidators([]);
    this.reportForm.controls['payment_date'].updateValueAndValidity();

    this.reportForm.controls['posted_on'].setValidators([]);
    this.reportForm.controls['posted_on'].updateValueAndValidity();

    this.reportForm.controls['invoice_status'].setValidators([]);
    this.reportForm.controls['invoice_status'].updateValueAndValidity();

    this.reportForm.controls['as_of_date'].setValidators([]);
    this.reportForm.controls['as_of_date'].updateValueAndValidity();
  }

  updateFormValidators(): void {
    if (this.selectedSecondaryReportOption == "suite") {
      this.reportForm.controls['suite'].setValidators([Validators.required]);
      this.reportForm.controls['suite'].updateValueAndValidity();
    }

    if (this.selectedSecondaryReportOption == 'account') {
      this.reportForm.controls['account'].setValidators([Validators.required]);
      this.reportForm.controls['account'].updateValueAndValidity();
    }

    if (this.selectedSecondaryReportOption == 'billing_period') {
      this.reportForm.controls['billing_period'].setValidators([Validators.required]);
      this.reportForm.controls['billing_period'].updateValueAndValidity();
    }

    if (this.selectedSecondaryReportOption == 'invoice_date') {
      this.reportForm.controls['invoice_date'].setValidators([Validators.required]);
      this.reportForm.controls['invoice_date'].updateValueAndValidity();
    }

    if (this.selectedSecondaryReportOption == 'invoice_status') {
      this.reportForm.controls['invoice_status'].setValidators([Validators.required]);
      this.reportForm.controls['invoice_status'].updateValueAndValidity();
    }

    if (this.selectedSecondaryReportOption == 'payment_date') {
      this.reportForm.controls['payment_date'].setValidators([Validators.required]);
      this.reportForm.controls['payment_date'].updateValueAndValidity();
    }

    if (this.selectedSecondaryReportOption == 'as_of_date') {
      this.reportForm.controls['as_of_date'].setValidators([Validators.required]);
      this.reportForm.controls['as_of_date'].updateValueAndValidity();
    }

    if (this.selectedSecondaryReportOption == 'posted_on') {
      this.reportForm.controls['posted_on'].setValidators([Validators.required]);
      this.reportForm.controls['posted_on'].updateValueAndValidity();
    }
  }
  async getSuite(): Promise<void> {

    this.loadingSearchOption = true;

    let suitesResult: any = await this.trpcService.trpc.invoice.getSuites.query().catch((error: any) => {
      this.messageService.add({
        severity: "error",
        detail: error.message,
      });
    });
    if (suitesResult?.length) {
      this.suiteOptions = suitesResult.map((suite: Suite) => { return { code: suite.suite, name: suite.name } })
      // this.selectedSuite = suitesResult[0]['suite'];
    }
    this.loadingSearchOption = false;

  }

  async getAccountBySuite(): Promise<void> {

    this.selectedSuiteAcct = '';
    this.suiteAcctOptions = [];

    if (this.selectedSuite && this.selectedSecondaryReportOption == "account") {

      this.loadingSearchOption = true;

      let acctsResult: any = await this.trpcService.trpc.invoice.getAccounts.query({ suite: this.selectedSuite }).catch((error: any) => {
        this.messageService.add({
          severity: "error",
          detail: error.message,
        });
      });
      if (acctsResult?.length) {
        this.suiteAcctOptions = acctsResult.map((acct: Account) => { return { code: acct.account_number, name: (acct.account_number + ' (' + acct.name + ')') } })
        // this.selectedSuiteAcct = acctsResult[0]['account_number'];
      }
      this.loadingSearchOption = false;
    }
  }

  async generateReport(): Promise<void> {
    console.log(this.reportForm.value);
    let params = Object.assign({}, this.reportForm.value);
    if (params['secondaryOption'] == "billing_period") {
      params['billing_period'] = this.months[params['billing_period'].getMonth()] + "-" + params['billing_period'].getFullYear();
    } else if (params['secondaryOption'] == "invoice_date") {
      let invoiceDates = params['invoice_date'];
      let fromDate = (invoiceDates[0].getMonth() + 1).toString() + "/" + invoiceDates[0].getDate().toString() + "/" + invoiceDates[0].getFullYear().toString();
      let toDate = (invoiceDates[1].getMonth() + 1).toString() + "/" + invoiceDates[1].getDate().toString() + "/" + invoiceDates[1].getFullYear().toString();
      params['invoice_date'] = fromDate + "-" + toDate;
    } else if (params['secondaryOption'] == "payment_date") {
      let invoiceDates = params['payment_date'];
      let fromDate = (invoiceDates[0].getMonth() + 1).toString() + "/" + invoiceDates[0].getDate().toString() + "/" + invoiceDates[0].getFullYear().toString();
      let toDate = (invoiceDates[1].getMonth() + 1).toString() + "/" + invoiceDates[1].getDate().toString() + "/" + invoiceDates[1].getFullYear().toString();
      params['payment_date'] = fromDate + "-" + toDate;
    } else if (params['secondaryOption'] == "as_of_date") {
      let asOfDate = params['as_of_date'];
      params['as_of_date'] = (asOfDate.getMonth() + 1).toString() + "/" + asOfDate.getDate().toString() + "/" + asOfDate.getFullYear().toString();
    } else if (params['secondaryOption'] == "posted_on") {
      let postedOnDates = params['posted_on'];
      let fromDate = (postedOnDates[0].getMonth() + 1).toString() + "/" + postedOnDates[0].getDate().toString() + "/" + postedOnDates[0].getFullYear().toString();
      let toDate = (postedOnDates[1].getMonth() + 1).toString() + "/" + postedOnDates[1].getDate().toString() + "/" + postedOnDates[1].getFullYear().toString();
      params['posted_on'] = fromDate + "-" + toDate;
    } else if(params['secondaryOption'] == "active_only") {
      params['active_only'] = params['active_only'] ? '1' : '0';
    }

    this.reportInProgress = true;
    let reportResult: any = await this.trpcService.trpc.reports.generateReport.query(params).catch((error: any) => {
      this.messageService.add({
        severity: "error",
        detail: error.message,
      });
    });
    this.reportInProgress = false;
    if (reportResult) {

      const buf = new Uint8Array(reportResult.data);
      let blob = new Blob([buf], { type: "application/pdf" });
      window.open(window.URL.createObjectURL(blob), "_blank", "top=100,left=100,width=600,height=500,status=yes,resizable=yes,scrollbars=yes,location=no");
    }
  }
}
